module.exports = __webpack_public_path__ + "media/stylesheets/images/media/userway_function_icons/icn-feature-02-8dc354089bd8eba71156fc858513e53d.svg";